/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { any } from 'prop-types';
import ProductInfoDivider from '../../ProductInfoDivider';
import SizeCollectionData from './SizeCollectionData';

const ModalContent = ({ showAllPlantersSizeChart }) => (
    <div className="size-chart-modal">
        <div>
            <p className="size-chart-title">Size chart</p>
            {SizeCollectionData(showAllPlantersSizeChart).map(({ title, planterFeatures, planterDetails }, index) => (
                <div className={`${SizeCollectionData().length !== index + 1 ? '' : 'last-item-margin'}`}>
                    <span className="planter-title">{title}</span>
                    <ul>
                        {planterFeatures.map((feature) => <li>{feature}</li>)}
                    </ul>
                    <div className="pot-images">
                        {planterDetails.map(({ imageSource, size, dimentions }) => (
                            <div className="pot-image-wrapper">
                                <div className="image-inner-wrapper">
                                    <img src={imageSource} alt={`${title}`} />
                                </div>
                                <div className="div-disc">
                                    <p className="planter-size">{size}</p>
                                    {dimentions.map((dimention) => (
                                        dimention.split(',').length > 1 ? <div className="align-dimension"><div><p>- {dimention.split(':')[0]}: </p></div><div>{dimention.split(',').map((splitedDimention) => <p className="align-values"> {splitedDimention.replace('Height:', '')}</p>)}</div></div> : <p>- {dimention}</p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    {SizeCollectionData(showAllPlantersSizeChart).length !== index + 1 && <ProductInfoDivider />}
                </div>
            ))}
        </div>
    </div>
);

ModalContent.propTypes = {
    showAllPlantersSizeChart: any.isRequired,
};

export default ModalContent;
